// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface SetMarketplaceActivationStateRequest
 */
export interface SetMarketplaceActivationStateRequest {
  /**
   * Whether the marketplace is active.
   * @type {boolean}
   * @memberof SetMarketplaceActivationStateRequest
   */
  isActive: boolean;
  /**
   * Reason for being inactive (applicable when isActive is false).
   * @type {string}
   * @memberof SetMarketplaceActivationStateRequest
   */
  inactiveReason?: string;
}

/**
 * Check if a given object implements the SetMarketplaceActivationStateRequest interface.
 */
export function instanceOfSetMarketplaceActivationStateRequest(
  value: object,
): value is SetMarketplaceActivationStateRequest {
  if (!('isActive' in value) || value['isActive'] === undefined) return false;
  return true;
}

export function SetMarketplaceActivationStateRequestFromJSON(
  json: any,
): SetMarketplaceActivationStateRequest {
  return SetMarketplaceActivationStateRequestFromJSONTyped(json, false);
}

export function SetMarketplaceActivationStateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetMarketplaceActivationStateRequest {
  if (json == null) {
    return json;
  }
  return {
    isActive: json['isActive'],
    inactiveReason:
      json['inactiveReason'] == null ? undefined : json['inactiveReason'],
  };
}

export function SetMarketplaceActivationStateRequestToJSON(
  json: any,
): SetMarketplaceActivationStateRequest {
  return SetMarketplaceActivationStateRequestToJSONTyped(json, false);
}

export function SetMarketplaceActivationStateRequestToJSONTyped(
  value?: SetMarketplaceActivationStateRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    isActive: value['isActive'],
    inactiveReason: value['inactiveReason'],
  };
}
